export default "__VITE_ASSET__CHeUsrEg__"